import React, { useState } from 'react';
import './LandingPage.css';

const LearnPage = ({ navigateTo }) => {
  const [selectedTopic, setSelectedTopic] = useState('basics');

  const topics = {
    basics: {
      title: "DeFi Basics",
      lessons: [
        {
          id: 1,
          title: "What is DeFi?",
          description: "Understand the fundamentals of Decentralized Finance",
          duration: "5 min read",
          completed: false
        },
        {
          id: 2,
          title: "Wallets and Security",
          description: "How to safely store and manage your crypto",
          duration: "7 min read",
          completed: false
        },
        {
          id: 3,
          title: "Understanding Gas Fees",
          description: "What are gas fees and how to optimize them",
          duration: "4 min read",
          completed: false
        }
      ]
    },
    uniswap: {
      title: "Uniswap Deep Dive",
      lessons: [
        {
          id: 4,
          title: "How Uniswap Works",
          description: "The mechanics of automated market makers",
          duration: "8 min read",
          completed: false
        },
        {
          id: 5,
          title: "Liquidity Provision",
          description: "Earn fees by providing liquidity to pools",
          duration: "6 min read",
          completed: false
        },
        {
          id: 6,
          title: "Uniswap v4 Hooks",
          description: "The revolutionary new hook system",
          duration: "10 min read",
          completed: false
        }
      ]
    },
    advanced: {
      title: "Advanced Topics",
      lessons: [
        {
          id: 7,
          title: "Flash Loans",
          description: "Borrow millions without collateral",
          duration: "12 min read",
          completed: false
        },
        {
          id: 8,
          title: "MEV and Protection",
          description: "Understanding and avoiding MEV",
          duration: "9 min read",
          completed: false
        },
        {
          id: 9,
          title: "Yield Farming Strategies",
          description: "Advanced strategies for maximizing returns",
          duration: "15 min read",
          completed: false
        }
      ]
    }
  };

  const handleLessonClick = (lesson) => {
    alert(`This lesson "${lesson.title}" will be available soon! For now, check out our YouTube videos.`);
  };

  return (
    <div className="app">
      {/* Header */}
      <header>
        <div className="container header-content">
          <h1 className="logo" onClick={() => navigateTo('home')} style={{cursor: 'pointer'}}>
            <span className="green">internet</span>
            <span className="purple">money</span>
            <span className="yellow">is</span>
            <span className="blue">serious</span>
            <span className="pink">.business</span>
          </h1>
          
          <nav className="main-nav">
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('home'); }} className="nav-link">Home</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('videos'); }} className="nav-link">Videos</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('learn'); }} className="nav-link active">Learn</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }} className="nav-link">About</a>
          </nav>
          
          <button className="subscribe-btn" onClick={() => navigateTo('home')}>
            Subscribe
          </button>
        </div>
      </header>

      {/* Learn Page Content */}
      <section className="page-content">
        <div className="container">
          <div style={{marginTop: '2rem', marginBottom: '2rem'}}>
            <h1>Learn DeFi</h1>
            <p style={{fontSize: '1.1rem', color: '#666', marginTop: '1rem'}}>
              Master DeFi concepts with our structured learning paths
            </p>
          </div>

          <div style={{display: 'flex', gap: '2rem', flexWrap: 'wrap'}}>
            {/* Topic Sidebar */}
            <div style={{flex: '0 0 250px'}}>
              <h3>Learning Paths</h3>
              <div style={{display: 'flex', flexDirection: 'column', gap: '0.5rem'}}>
                {Object.entries(topics).map(([key, topic]) => (
                  <button
                    key={key}
                    onClick={() => setSelectedTopic(key)}
                    style={{
                      padding: '1rem',
                      borderRadius: '8px',
                      border: selectedTopic === key ? '2px solid #6366f1' : '2px solid #e5e7eb',
                      backgroundColor: selectedTopic === key ? '#f0f9ff' : 'white',
                      textAlign: 'left',
                      cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                  >
                    <div style={{fontWeight: 'bold', marginBottom: '0.25rem'}}>
                      {topic.title}
                    </div>
                    <div style={{fontSize: '0.9rem', color: '#666'}}>
                      {topic.lessons.length} lessons
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Lessons Content */}
            <div style={{flex: '1'}}>
              <h2>{topics[selectedTopic].title}</h2>
              <div style={{display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem'}}>
                {topics[selectedTopic].lessons.map((lesson, index) => (
                  <div
                    key={lesson.id}
                    onClick={() => handleLessonClick(lesson)}
                    style={{
                      padding: '1.5rem',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      backgroundColor: 'white',
                      transition: 'all 0.2s',
                      ':hover': {
                        borderColor: '#6366f1',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                      }
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.borderColor = '#6366f1';
                      e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.borderColor = '#e5e7eb';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                      <div style={{
                        width: '2rem',
                        height: '2rem',
                        borderRadius: '50%',
                        backgroundColor: lesson.completed ? '#10b981' : '#6366f1',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold'
                      }}>
                        {lesson.completed ? '✓' : index + 1}
                      </div>
                      <div style={{flex: '1'}}>
                        <h4 style={{margin: '0 0 0.5rem 0'}}>{lesson.title}</h4>
                        <p style={{margin: '0', color: '#666'}}>{lesson.description}</p>
                        <div style={{marginTop: '0.5rem', fontSize: '0.9rem', color: '#999'}}>
                          {lesson.duration}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div style={{
            marginTop: '3rem',
            padding: '2rem',
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            textAlign: 'center'
          }}>
            <h3>Want More Content?</h3>
            <p>Our YouTube and TikTok channels have hundreds of short-form educational videos</p>
            <div style={{marginTop: '1rem'}}>
              <a 
                href="https://youtube.com/@internetmoneyisserious" 
                target="_blank" 
                rel="noopener noreferrer"
                className="cta-btn youtube"
                style={{marginRight: '1rem'}}
              >
                YouTube Channel
              </a>
              <a 
                href="https://tiktok.com/@internetmoneyisserious" 
                target="_blank" 
                rel="noopener noreferrer"
                className="cta-btn tiktok"
              >
                TikTok Profile
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{marginTop: '3rem'}}>
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h2 className="logo">
                <span className="green">internet</span>
                <span className="purple">money</span>
                <span className="yellow">is</span>
                <span className="blue">serious</span>
                <span className="pink">.business</span>
              </h2>
              <p>DeFi education in bite-sized videos</p>
            </div>
            
            <div className="footer-links">
              <a href="https://youtube.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer">YouTube</a>
              <a href="https://tiktok.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer">TikTok</a>
              <a href="https://twitter.com/imseriousbiz" target="_blank" rel="noopener noreferrer">Twitter</a>
              <a href="https://discord.gg/defi" target="_blank" rel="noopener noreferrer">Discord</a>
              <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }}>Contact</a>
            </div>
          </div>
          
          <div className="copyright">
            &copy; {new Date().getFullYear()} internetmoneyisserious.business | Not financial advice
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LearnPage;